const CENTS_PER_UNIT = 100;

export const toCents = (value) => {
  const amount = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(amount)) {
    return Number.NaN;
  }

  return Math.round((amount + Math.sign(amount) * Number.EPSILON) * CENTS_PER_UNIT);
};

export const fromCents = (cents) => cents / CENTS_PER_UNIT;

export const normalizeMoney = (value) => fromCents(toCents(value));

export const addMoney = (left, right) => fromCents(toCents(left) + toCents(right));

export const subtractMoney = (left, right) => fromCents(toCents(left) - toCents(right));
